import { TubeProduct } from '../enum'

const oligoPropertiesMap = {
  Amount: {
    id: 'AMOUNT',
    defaultMessage: 'Amount',
    oligoObjPropName: 'amount',
  },
  Scale: { id: 'SCALE', defaultMessage: 'Scale', oligoObjPropName: 'scale' },
  Purification: {
    id: 'PURIFICATION',
    defaultMessage: 'Purification',
    oligoObjPropName: 'purification',
  },
  Format: {
    id: 'Format',
    defaultMessage: 'Format',
    oligoObjPropName: 'format',
  },
  Concentration: {
    id: 'CONCENTRATION',
    defaultMessage: 'Concentration',
    oligoObjPropName: 'concentration',
  },
  Tubes: { id: 'TUBES', defaultMessage: 'Tubes', oligoObjPropName: 'tubes' },
  Bases: {
    id: 'BASES',
    defaultMessage: 'Bases',
    oligoObjPropName: 'baseCount',
  },
  Services: {
    id: 'SERVICES',
    defaultMessage: 'Services',
    oligoObjPropName: 'additionalServices',
  },
}

const {
  Amount,
  Scale,
  Purification,
  Format,
  Concentration,
  Tubes,
  Bases,
  Services,
} = oligoPropertiesMap
export const getConfirmOrderTableItemsByProduct = (product) => {
  switch (product) {
    case TubeProduct.Standard:
      return [Scale, Purification, Format, Concentration, Tubes, Bases]
    case TubeProduct.EasyOligo:
      return [Amount, Purification, Format, Concentration, Bases]
    case TubeProduct.Rna:
      return [Scale, Purification, Format, Concentration, Tubes, Bases]
    case TubeProduct.PureSimple:
      return [Amount, Purification, Format, Bases]
    case TubeProduct.iscaledna:
      return [Amount, Purification, Services, Tubes, Bases]
    case TubeProduct.LongOligo:
      return [Amount, Purification, Format, Bases]
    case TubeProduct.Wellred:
      return [Amount, Purification, Format, Tubes, Bases]
    case TubeProduct.Beacon:
      return [Amount, Purification, Format, Tubes, Bases]
    case TubeProduct.Probe:
      return [Amount, Purification, Tubes, Bases]
    default:
      return []
  }
}
